/**
 * Utilities for Google Analytics and Meta Pixel initialization
 */
import ReactGA from 'react-ga';

/**
 * Initialize Google Analytics with dynamic tracking ID
 * @param {string} trackingId - Google Analytics ID (GA4: G-XXXXXXXXXX or Universal: UA-XXXXXXXXX-X)
 */
export const initializeGoogleAnalytics = (trackingId) => {
  if (!trackingId || trackingId.trim() === '') {
    // console.warn('Google Analytics tracking ID not provided');
    return;
  }

  try {
    ReactGA.initialize(trackingId);
  } catch (error) {
    // console.error('Error initializing Google Analytics:', error);
  }
};

/**
 * Initialize Meta Pixel with dynamic pixel ID
 * @param {string} pixelId - Meta Pixel ID (15-16 digit number)
 */
export const initializeMetaPixel = (pixelId) => {
  if (!pixelId || pixelId.trim() === '') {
    // console.warn('Meta Pixel ID not provided');
    return;
  }

  try {
    // Verifica se o script do Meta Pixel já foi injetado
    if (window.fbq) {
      return;
    }

    // Injeta o script do Meta Pixel
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://connect.facebook.net/en_US/fbevents.js`;

    script.onload = () => {
      // Inicializa o fbq após o script carregar
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    };

    script.onerror = () => {
      console.error('Error loading Meta Pixel script');
    };

    document.head.appendChild(script);

    // Cria a função fbq se ainda não existir
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
  } catch (error) {
    console.error('Error initializing Meta Pixel:', error);
  }
};

/**
 * Track a page view with Google Analytics
 * @param {string} path - Page path
 */
export const trackPageView = (path) => {
  try {
    ReactGA.pageview(path);
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

/**
 * Track an event with Meta Pixel
 * @param {string} eventName - Event name (e.g., 'AddToCart', 'Purchase')
 * @param {object} data - Event data
 */
export const trackMetaPixelEvent = (eventName, data = {}) => {
  if (typeof window.fbq === 'function') {
    try {
      window.fbq('track', eventName, data);
    } catch (error) {
      console.error('Error tracking Meta Pixel event:', error);
    }
  }
};

/**
 * Track an event with Google Analytics
 * @param {string} category - Event category
 * @param {string} action - Event action
 * @param {string} label - Event label
 * @param {object} value - Event value
 */
export const trackGAEvent = (category, action, label, value) => {
  try {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  } catch (error) {
    console.error('Error tracking GA event:', error);
  }
};
